<div class="footer-container d-flex h-100 w-100 align-items-center shadow-footer">
  
  <!-- Left/Center: Selected Product Info -->
  <div class="product-info-section d-flex align-items-center flex-grow-1 px-4 overflow-hidden" *ngIf="productReference != null; else placeholder">
    
    <button class="btn btn-sm btn-icon btn-outline-light me-3 rounded-circle" (click)="closeInspector()" title="Close Inspector">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="d-flex flex-column text-light">
      <div class="d-flex align-items-baseline gap-2">
        @if (isColumnVisible('brand')) {
          <span class="fw-bold fs-6 text-truncate">{{productReference.brand}}</span>
        }
        @if (isColumnVisible('brand') && isColumnVisible('description')) {
          <span class="text-secondary-subtle">|</span>
        }
        @if (isColumnVisible('description')) {
          <span class="fs-6 text-truncate">{{productReference.description}}</span>
        }
      </div>
      
      <div class="d-flex gap-3 text-white-50 fs-7 mt-1">
        @if (isColumnVisible('barcode')) {
          <span><i class="bi bi-upc me-1"></i>{{productReference.barcode}}</span>
        }
        @if (isColumnVisible('nationalId') && productReference.nationalId) {
          <span><i class="bi bi-tag me-1"></i>{{productReference.nationalId}}</span>
        }
        @if (isColumnVisible('uos') || isColumnVisible('unit')) {
          <span><i class="bi bi-box-seam me-1"></i>{{isColumnVisible('uos') ? productReference.uos : ''}}{{isColumnVisible('unit') ? ' ' + productReference.unit : ''}}</span>
        }
        @if (isColumnVisible('orientation')) {
          <span><i class="bi bi-arrows-angle-expand me-1"></i> {{ ProductOrientation[productReference.orientation] }}</span>
        }
        @if (isColumnVisible('dimensions')) {
          <span>
            <i class="bi bi-rulers me-1"></i>
            W: {{productReference.dimensions.width.toFixed(1)}} | H: {{productReference.dimensions.height.toFixed(1)}} | D: {{productReference.dimensions.depth.toFixed(1)}}
          </span>
        }
        
        <span class="border-start border-secondary mx-1"></span>

        @if (isColumnVisible('dos')) {
          <span [class.text-warning]="getLayoutDOS(productReference.productId) < 1" 
                [class.text-success]="getLayoutDOS(productReference.productId) >= 1"
                *ngIf="!Number.isNaN(getLayoutDOS(productReference.productId))">
                <i class="bi bi-calendar-range me-1"></i>DOS: {{getLayoutDOS(productReference.productId).toFixed(2)}}
          </span>
        }
        @if (isColumnVisible('sales')) {
          <span><b class="me-1">R:</b>{{productReference.salesData.sales.toFixed(2)}}</span>
        }
        @if (isColumnVisible('volume')) {
          <span><i class="bi bi-bar-chart-fill me-1"></i>Vol: {{productReference.salesData.salesQty.toFixed(2)}}</span>
        }
      </div>
    </div>

    <button class="btn btn-sm btn-icon btn-outline-light ms-auto" (click)="openColumnSelect()" title="Configure Columns">
      <i class="bi bi-gear"></i>
    </button>
  </div>

  <ng-template #placeholder>
    <div class="flex-grow-1 px-4 text-white-50 fst-italic fs-7">
      <span *ngIf="router.url.includes('/planogram')">Select a product to view details</span>
    </div>
  </ng-template>

  <!-- Right: Planogram Stats -->
  <div class="stats-section d-flex flex-row gap-3 pe-4 align-items-center border-start border-secondary py-2 ps-3">
    @if (currentStatus != null && planogramService.getPlanogram() != null) {
      <div class="stat-pill" title="Store Name">
        <i class="bi bi-shop me-2 text-primary-subtle"></i>
        <span>{{planogramService.getStoreName()}}</span>
      </div>
      <div class="stat-pill" title="Merchandise Set">
        <i class="bi bi-collection me-2 text-primary-subtle"></i>
        <span>{{planogramService.getMerchName()}}</span>
      </div>
      <div class="stat-pill" title="Drops Count">
        <i class="bi bi-grid-3x3 me-2 text-primary-subtle"></i>
        <span>{{planogramService.getTargetDrops()}} Drops</span>
      </div>
      @if (planogramService.getSalesPeriodStart() && planogramService.getSalesPeriodEnd()) {
        <div class="stat-pill" title="Sales Period">
          <i class="bi bi-calendar3 me-2 text-primary-subtle"></i>
          <span>{{planogramService.getSalesPeriodStart() | date:'MM/yyyy'}} &ndash; {{planogramService.getSalesPeriodEnd() | date:'MM/yyyy'}}</span>
        </div>
      }
      @if (avgDOSWeighted != null) {
        <div class="stat-pill" title="Average Weighted DOS">
          <i class="bi bi-speedometer2 me-2 text-primary-subtle"></i>
          <span>Avg DOS: {{ avgDOSWeighted }}</span>
        </div>
      }
    }
  </div>
</div>